import 'intersection-observer'
import Vue from 'vue'
import App from './App.vue'
import VueAgile from 'vue-agile'
import VueZoomer from 'vue-zoomer';

import inViewportDirective from 'vue-in-viewport-directive'

Vue.config.productionTip = false
Vue.use(VueAgile)
Vue.use(VueZoomer);

inViewportDirective.defaults.margin = '-10% 0%'
Vue.directive('in-viewport', inViewportDirective)

new Vue({
  render: h => h(App),
}).$mount('#app')
